
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"20","viewBox":"0 0 16 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8 6C6.89528 6 6 6.89528 6 8C6 9.10472 6.89528 10 8 10C9.10472 10 10 9.10472 10 8C10 6.89528 9.10472 6 8 6ZM4 8C4 5.79072 5.79072 4 8 4C10.2093 4 12 5.79072 12 8C12 10.2093 10.2093 12 8 12C5.79072 12 4 10.2093 4 8Z","fill":"#AEBCC8"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8 2C4.68629 2 2 4.68629 2 8C2 10.2428 3.53285 12.7523 5.26728 14.8274C6.11083 15.8367 6.95719 16.6909 7.59363 17.2932C7.74172 17.4334 7.87809 17.5596 8 17.6706C8.12191 17.5596 8.25828 17.4334 8.40637 17.2932C9.04282 16.6909 9.88917 15.8367 10.7327 14.8274C12.4672 12.7523 14 10.2428 14 8C14 4.68629 11.3137 2 8 2ZM8 19C7.36526 19.7727 7.36506 19.7726 7.36484 19.7724L7.36263 19.7706L7.35745 19.7663L7.33965 19.7515C7.32452 19.7389 7.30293 19.7208 7.27532 19.6974C7.22011 19.6507 7.14076 19.5828 7.04071 19.4953C6.84071 19.3202 6.55753 19.0663 6.21887 18.7458C5.54281 18.106 4.63917 17.1946 3.73272 16.1101C1.96715 13.9977 0 11.0072 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 11.0072 14.0328 13.9977 12.2673 16.1101C11.3608 17.1946 10.4572 18.106 9.78113 18.7458C9.44247 19.0663 9.15929 19.3202 8.95929 19.4953C8.85924 19.5828 8.77989 19.6507 8.72468 19.6974C8.69707 19.7208 8.67548 19.7389 8.66035 19.7515L8.64255 19.7663L8.63737 19.7706L8.63574 19.7719C8.63551 19.7721 8.63474 19.7727 8 19ZM8 19L8.63474 19.7727C8.26583 20.0758 7.73375 20.0754 7.36484 19.7724L8 19Z","fill":"#AEBCC8"}})])
          )
        }
      }
    